// @flow
import Vue from 'vue'

/**
 * Require and code split / lazy load search related components
 *
 * Also contains
 * - custom workout form components
 * - routine builder components
 * - plans scheduling
 * - product cards (gift card)
 *
 * This is because there is a lot of overlap and both routines / custom workouts / plans
 * that leverage "search" capabilities, so made sense to bundle here vs tons of smaller
 * code splitting.
 *
 * If they grow, we can split into separate chunks.
 */
const searchCodeSplit = () => {
  /* ROUTINES */
  // routines are apart of the search chunk as they use video / favorites pages
  Vue.component('routine-info-form', () =>
    import(/* webpackChunkName: "search" */ '../components/routines/routine-info-form.vue'),
  )
  Vue.component('routine-schedule', () =>
    import(/* webpackChunkName: "search" */ '../components/routines/routine-schedule.vue'),
  )
  Vue.component('routine-meta-data', () =>
    import(/* webpackChunkName: "search" */ '../components/routines/routine-meta-data.vue'),
  )
  Vue.component('routine-instructions-carousel', () =>
    import(
      /* webpackChunkName: "search" */ '../components/routines/routine-instructions-carousel.vue'
    ),
  )

  /* PLANS */
  Vue.component('reschedule-form', () =>
    import(/* webpackChunkName: "search" */ '../components/plans/reschedule-form.vue'),
  )

  /* CUSTOM WORKOUTS */
  Vue.component('custom-workout-form', () =>
    import(
      /* webpackChunkName: "search" */ '../components/custom-workouts/custom-workout-form.vue'
    ),
  )

  /* PRODUCTS */
  Vue.component('gift-card', () =>
    import(/* webpackChunkName: "search" */ '../components/products/gift-card.vue'),
  )

  /* TEAM MEMBER */
  Vue.component('team-member-card', () =>
    import(/* webpackChunkName: "search" */ '../components/team-members/team-member-card.vue'),
  )
  Vue.component('recent-article-widget', () =>
    import(/* webpackChunkName: "search" */ '../components/team-members/recent-article-widget.vue'),
  )
  Vue.component('recent-workout-widget', () =>
    import(/* webpackChunkName: "search" */ '../components/team-members/recent-workout-widget.vue'),
  )
}

export default searchCodeSplit
